'use client'
import { useTranslate } from '@repo/shared/hooks'
import { Alert, Card, Col, Icon, Row, Typography } from '@repo/ui/components'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { KycForm } from './kyc.form'
import { KycSuccess } from './kyc.success'
import { KycLoading } from './kyc.loading'
import { ButtonLink } from '@repo/shared/components'
import { useUserAuthDetails } from '@repo/services'
import { useRouter } from '@repo/shared/i18n/navigation'

export const KycContainer = () => {
  const { t } = useTranslate()
  const [isSuccess, setIsSuccess] = useState(false)
  const searchParams = useSearchParams()
  const mobileOrEmail = searchParams.get('mobileOrEmail') ?? ''
  const isConfirmed = searchParams.get('confirmed') ?? ''
  const { replace } = useRouter()

  const { data: authDetails, isPending } = useUserAuthDetails()
  const hasKyc =
    authDetails?.data.details?.kyc &&
    (authDetails?.data.details?.kyc?.status === 'approved' ||
      authDetails?.data.details?.kyc?.status === 'waiting_for_review' ||
      authDetails?.data.details?.kyc?.status === 'under_review')

  useEffect(() => {
    if (isConfirmed) {
      setIsSuccess(true)
    }
  }, [isConfirmed])

  // Check if user has completed KYC and redirect
  useEffect(() => {
    if (!isPending && hasKyc) {
      replace('/profile/account')
    }
  }, [hasKyc, isPending, replace])

  // Show skeleton while loading
  if (hasKyc || isPending) {
    return <KycLoading />
  }

  if (isSuccess) {
    return (
      <div className='px-md'>
        <KycSuccess mobileOrEmail={mobileOrEmail} />
      </div>
    )
  }

  return (
    <div className='px-md'>
      <Card className='p-xl rounded-sm'>
        <Col className='gap-3xl'>
          <Row className='justify-between'>
            <Typography size='2xl' weight='bold'>
              {t('common_kyc_title')}
            </Typography>
            <Row className='gap-xs w-fit'>
              <ButtonLink href='/dashboard' size='sm' color='neutral'>
                {t('common_later')}
              </ButtonLink>
            </Row>
          </Row>

          <Alert
            color='base'
            caption={t('common_kyc_alert_description', {
              company_name: t('company_name'),
            })}
            icon={<Icon name='AlertTriangleLine' />}
          />

          <KycForm
            onSuccess={() => setIsSuccess(true)}
            mobileOrEmail={mobileOrEmail}
          />

          {/* <ButtonLink
            variant='ghost'
            width='full'
            size='lg'
            href='/auth/mobile-kyc'
            color='neutral'
          >
            {t('common_register_mobile')}
          </ButtonLink> */}
        </Col>
      </Card>
    </div>
  )
}
